import type { RenderFilter, RenderProfileFieldFilter } from "./types";
import { useCrmTrueLocationFieldAndSearchEnabled } from "./useCrmLocationEnabled";

const filterIsLocationProfileField = (filter: RenderFilter) =>
  filter.name === "location" ||
  (filter.name === "profile_field" && filter.label === "Location");

const filterIsGeoLocation = (filter: RenderFilter) =>
  filter.name === "geo_location";

export const useShouldShowGeolocationFilter = <
  T extends RenderFilter[] | RenderProfileFieldFilter[],
>(
  filters: T,
): T => {
  const isCrmTrueLocationFieldAndSearchEnabled =
    useCrmTrueLocationFieldAndSearchEnabled();

  if (isCrmTrueLocationFieldAndSearchEnabled) {
    return filters.filter(filter => !filterIsLocationProfileField(filter)) as T;
  }

  return filters.filter(filter => !filterIsGeoLocation(filter)) as T;
};
